export const ContactModel = {
  telephone: "",
  phone: "",
  email: "",
};

export class ContactDecorator {
  constructor(telephone) {
    this.telephone = telephone;
  }

  toRequest() {
    return {
      telephone: this.telephone.telephone,
      phone: this.telephone.phone,
      email: this.telephone.email,
    };
  }
}
